import Footer from "../components/Footer";
import Header from "../components/Header";

import WhyChooseUs from "../components/Service/whychooseus";
import TitleBanner from "../components/titlebanner";

export default function Services() {
    return (
        <>
        <Header/>
        <TitleBanner title={"Service List"}/>
        <WhyChooseUs/>
        <Footer/>
        </>
       
    )
}